export default function ContatoSection() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    const textarea = form.querySelector('textarea[name="mensagem"]') as HTMLTextAreaElement;
    if (textarea && textarea.value.length > 500) {
      alert('A mensagem não pode exceder 500 caracteres.');
      return;
    }
    
    const data = new URLSearchParams();
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d5si2l46pqudvsuu5500', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString()
      });
      
      if (response.ok) {
        alert('Solicitação enviada com sucesso! Entraremos em contato em breve.');
        form.reset();
      } else {
        alert('Erro ao enviar solicitação. Por favor, tente novamente.');
      }
    } catch (error) {
      alert('Erro ao enviar solicitação. Por favor, tente novamente.');
    }
  };

  return (
    <section id="contato" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B3A6E] mb-4">
            Entre em Contato
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Fale conosco para saber mais sobre data center, backup corporativo e hospedagem de servidores em Manaus.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#0B3A6E] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#0B3A6E] mb-2">Telefone</h3>
                  <a href="tel:+5592991426889" className="text-gray-600 hover:text-[#F5A623] transition-colors cursor-pointer">
                    (92) 99142-6889
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#0B3A6E] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#0B3A6E] mb-2">Email</h3>
                  <a href="mailto:contato@neotec.inf.br" className="text-gray-600 hover:text-[#F5A623] transition-colors cursor-pointer">
                    contato@neotec.inf.br
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#0B3A6E] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#0B3A6E] mb-2">Endereço</h3>
                  <p className="text-gray-600 mb-4">
                    Rua Alexandre Magno, 519<br />
                    Parque 10 de Novembro<br />
                    Manaus - AM
                  </p>
                  <div className="flex flex-wrap gap-3">
                    <a 
                      href="https://www.google.com/maps/search/?api=1&query=Rua+Alexandre+Magno+519+Parque+10+de+Novembro+Manaus+AM" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="bg-[#0B3A6E] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#1a5a9e] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
                    >
                      <i className="ri-map-pin-2-line"></i>
                      Abrir no Google Maps
                    </a>
                    <a 
                      href="https://waze.com/ul?q=Rua+Alexandre+Magno+519+Parque+10+de+Novembro+Manaus+AM" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="bg-[#F5A623] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#E09515] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
                    >
                      <i className="ri-navigation-line"></i>
                      Abrir no Waze
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <a 
              href="https://wa.me/5592991426889" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block bg-gradient-to-r from-[#25D366] to-[#128C7E] text-white px-8 py-6 rounded-xl text-lg font-semibold hover:from-[#20BD5A] hover:to-[#0F7A6C] transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl text-center"
            >
              <i className="ri-whatsapp-line text-2xl mr-2"></i>
              Falar no WhatsApp
            </a>
          </div>

          <div className="bg-gradient-to-br from-[#0B3A6E] to-[#1a5a9e] rounded-xl p-8 lg:p-12 text-white shadow-xl">
            <h3 className="text-3xl font-bold mb-6">
              Solicite uma Proposta
            </h3>
            <p className="text-gray-200 mb-8 leading-relaxed">
              Preencha o formulário abaixo e nossa equipe entrará em contato para apresentar as melhores soluções de data center, backup corporativo e hospedagem de servidores em Manaus para sua empresa.
            </p>
            
            <form className="space-y-6" data-readdy-form id="proposta-form" onSubmit={handleSubmit}>
              <div>
                <label className="block text-sm font-medium mb-2">Nome Completo</label>
                <input 
                  type="text" 
                  name="nome"
                  required
                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#F5A623] focus:border-transparent"
                  placeholder="Seu nome"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-2">Email</label>
                <input 
                  type="email" 
                  name="email"
                  required
                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#F5A623] focus:border-transparent"
                  placeholder="seu@email.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-2">Telefone</label>
                <input 
                  type="tel" 
                  name="telefone"
                  required
                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#F5A623] focus:border-transparent"
                  placeholder="(92) 99999-9999"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-2">Empresa</label>
                <input 
                  type="text" 
                  name="empresa"
                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#F5A623] focus:border-transparent"
                  placeholder="Nome da empresa"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-2">Serviço de Interesse</label>
                <select 
                  name="servico"
                  required
                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:outline-none focus:ring-2 focus:ring-[#F5A623] focus:border-transparent cursor-pointer"
                >
                  <option value="" className="text-gray-900">Selecione um serviço</option>
                  <option value="Data Center" className="text-gray-900">Suporte em Data Center</option>
                  <option value="Backup Corporativo" className="text-gray-900">Backup Corporativo</option>
                  <option value="Hospedagem de Servidores" className="text-gray-900">Hospedagem de Servidores Virtuais</option>
                  <option value="Todos os Serviços" className="text-gray-900">Todos os Serviços</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-2">Mensagem</label>
                <textarea 
                  name="mensagem"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#F5A623] focus:border-transparent resize-none"
                  placeholder="Conte-nos mais sobre suas necessidades (máximo 500 caracteres)"
                ></textarea>
              </div>
              
              <button 
                type="submit"
                className="w-full bg-[#F5A623] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#E09515] transition-colors cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
              >
                Enviar Solicitação
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}